import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/online_status/element.js';
import '@effectivastudio/lit-components/components/avatar/element.js';
import style from './style.lit.css';

/**
 * An element representing a platform member. The whole element is a link to members profile. Online status will be automatically updated using `uid` and `OnlineStatus` class.
 *
 * @prop uid - ID of the user.
 * @prop name - Name of the user - for avatar. (optional)
 * @prop url - URL to users profile. (optional)
 * @prop picture - URL for avatar picture. (optional)
 *
 * @slot title - For the element title - most likely the name of the user.
 * @slot info - For secondary text just below the title.
 * @slot actions - For a list of featured actions on the right side.
 * @slot details - For additional elements going below main (avatar + title + info + actions ) content.
 */

export default class Member extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    uid: { type: Number },
    name: { type: String },
    url: { type: String },
    picture: { type: String },
  };

  constructor() {
    super();
    this.addEventListener('click', this);
  }

  /** @internal */
  get currentUser() {
    return this.AppConfig?.user?.id === this.uid;
  }

  handleEvent(e) {
    if (e.type === 'click') this.handleClick(e);
  }

  handleClick(e) {
    if (!this.url || e.target.tagName !== 'BU-MEMBER') return;

    this.shadowRoot.querySelector('a').click();
  }

  renderSlot() {
    return html`<slot name="title"></slot>`;
  }

  renderSlotWithLink() {
    return html` <a href=${this.url}>${this.renderSlot()}</a> `;
  }

  render() {
    return html`
      <div class="main">
        <ef-avatar
          class=${this.currentUser ? 'my' : ''}
          .picture=${this.picture}
          .name=${this.name}
          rounded>
          <ef-online-status .uid=${this.uid}> </ef-online-status>
        </ef-avatar>
        <div class="info">
          ${this.url ? this.renderSlotWithLink() : this.renderSlot()}
          <slot name="info"></slot>
        </div>
        <div class="actions">
          <slot name="actions"></slot>
        </div>
      </div>
      <slot name="details"></slot>
    `;
  }
}

Member.registerTagName('bu-member');

customElements.get('bu-member') || customElements.define('bu-member', Member);
